<template>
    <div class="tag-input flex inline-flex flex-wrap gap-2">
        <BadgePill v-for="tag in modelValue" :key="tag" class="tag-input-tag">
            <span>{{ tag }}</span>
            <button
                type="button"
                class="tag-input-remove shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white"
                @click="removeTag(tag)"
            >
                &times;
            </button>
        </BadgePill>
        <input
            class="tag-input-text bg-gray-50"
            :placeholder="tagPlaceholder"
            v-model="input"
            @paste="onPaste"
            @keydown.backspace="handleBackspace"
            @keydown.enter.prevent="addTag"
        />
    </div>
</template>

<script>
import BadgePill from '@/components/BadgePill.vue';

export default {
    emits: ['update:modelValue'],
    name: 'TagsInput',
    components: {
        BadgePill,
    },
    props: {
        modelValue: {
            type: Array,
            required: false,
            default: () => [],
        },
        addTagPlaceholder: {
            type: String,
        },
    },
    data() {
        return {
            input: '',
            tagPlaceholder: this.addTagPlaceholder || this.$t('messages.add_tag'),
        };
    },
    computed: {
        newTag() {
            return this.input.trim();
        },
    },
    methods: {
        onPaste(event) {
            event.stopPropagation();
            event.preventDefault();
            const data = event.clipboardData && event.clipboardData.getData('text');
            if (data) {
                let delimiter = '\n';
                let items = data.split(delimiter).map((s) => s.trim());

                const existingItems = this.modelValue;
                const newSet = existingItems.concat(items);
                items = [...new Set(newSet)];
                this.updateTags(items);
            }
        },
        removeTag(tag) {
            this.$emit(
                'update:modelValue',
                this.modelValue.filter((t) => t !== tag),
            );
        },
        addTag() {
            if (this.newTag.length === 0 || this.modelValue.includes(this.newTag)) {
                return;
            }
            this.$emit('update:modelValue', [...this.modelValue, this.newTag]);
            this.clearInput();
        },
        clearInput() {
            this.input = '';
        },
        handleBackspace() {
            if (this.newTag.length === 0) {
                this.$emit('update:modelValue', this.modelValue.slice(0, -1));
            }
        },
        updateTags(tags) {
            this.$emit('update:modelValue', tags);
        },
    },
};
</script>
